import React, { useState, useEffect } from "react";
import axios from "../../utils/axiosConfig";
import { BASE_URL } from "../../utils/config";
import "../Staffs/Staffs.css";

const Staffs = () => {

  const [staffdata, setStaffData] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState("All");



  /* FETCH STAFF FROM MYSQL */

  useEffect(() => {

    const fetchStaff = async () => {
      try {

        const res = await axios.get("/api/staffs");

        setStaffData(res.data);

      } catch (err) {
        console.error("Staff fetch error:", err);
      }
    };

    fetchStaff();

  }, []);




  const handleOpenModal = (index) => {
    setSelectedIndex(index);
  };

  const handleCloseModal = () => {
    setSelectedIndex(null);
  };

  /* FILTER + SEARCH */
  const filteredStaff = staffdata.filter((staff) => {

    const matchSearch =
      staff.names.toLowerCase().includes(search.toLowerCase());

    const matchFilter =
      filter === "All" || staff.designation.includes(filter);

    return matchSearch && matchFilter;
  });



  /* KEYBOARD NAVIGATION */

  useEffect(() => {

    const handleKeyDown = (e) => {

      if (selectedIndex !== null) {

        if (e.key === "ArrowRight") {

          setSelectedIndex((prev) =>
            prev === filteredStaff.length - 1 ? 0 : prev + 1
          );

        }

        if (e.key === "ArrowLeft") {

          setSelectedIndex((prev) =>
            prev === 0 ? filteredStaff.length - 1 : prev - 1
          );

        }

        if (e.key === "Escape") {
          handleCloseModal();
        }

      }

    };

    window.addEventListener("keydown", handleKeyDown);

    return () => window.removeEventListener("keydown", handleKeyDown);

  }, [selectedIndex, filteredStaff.length]);



  return (

    <div className="container staff-container">

      <h4 className="text-center mb-2">
        OUR FACULTY & STAFF MEMBERS
      </h4>

      <h5>
        The Heartbeat of North Point Children's Academy — Inspiring Today, Leading Tomorrow.
      </h5>



      {/* SEARCH + FILTER */}

      <div className="staff-controls">

        <input
          type="text"
          placeholder="Search staff..."
          className="form-control staff-search"
          onChange={(e) => setSearch(e.target.value)}
        />

        <select
          className="form-select staff-filter"
          onChange={(e) => setFilter(e.target.value)}
        >

          <option value="All">All Staff</option>
          <option value="Principal">Principal</option>
          <option value="PGT">PGT</option>
          <option value="TGT">TGT</option>
          <option value="PRT">PRT</option>

        </select>

      </div>



      {/* STAFF GRID */}

      <div className="row g-4">

        {filteredStaff.map((staff, index) => (

          <div key={staff.id} className="col-12 col-sm-6 col-md-4 col-lg-3">

            <div
              className="card staff-card h-100 shadow-sm"
              onClick={() => handleOpenModal(index)}
              style={{ cursor: "pointer" }}
            >

              <img
                src={`${BASE_URL}/uploads/staffs/${staff.imgpic}`}
                alt={staff.names}
                className="card-img-top staff-img"
                loading="lazy"
              />

              <div className="card-body">

                <h5 className="card-title">
                  {staff.names}
                </h5>

                <p className="card-text">

                  <strong>Status:</strong> {staff.status}

                  <br />

                  <strong>Designation:</strong> {staff.designation}

                  <br />

                  <strong>DOA:</strong> {staff.stfdoa}

                  <br />

                  <strong>Qualification:</strong> {staff.qualification}

                </p>

              </div>

            </div>

          </div>

        ))}

      </div>



      {/* MODAL */}

      {selectedIndex !== null && (

        <div
          className="modal fade show d-block"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >

          <div className="modal-dialog modal-lg modal-dialog-centered">

            <div className="modal-content">

              <div className="modal-header">

                <h5 className="modal-title">
                  {filteredStaff[selectedIndex].names}
                </h5>

                <button
                  className="btn btn-secondary"
                  onClick={handleCloseModal}
                >
                  Close
                </button>

              </div>



              <div className="modal-body">

                <div className="row g-3">

                  {/* PHOTO */}

                  <div className="col-md-5 text-center">

                    <img
                      src={`${BASE_URL}/uploads/staffs/${filteredStaff[selectedIndex].imgpic}`}
                      alt=""
                      className="modal-main-img"
                    />

                  </div>



                  {/* DETAILS */}

                  <div className="col-md-7">

                    <ul className="list-group staff-details">

                      <li className="list-group-item">
                        <strong>Gender:</strong> {filteredStaff[selectedIndex].gender}
                      </li>

                      <li className="list-group-item">
                        <strong>Marital:</strong> {filteredStaff[selectedIndex].marital}
                      </li>

                      <li className="list-group-item">
                        <strong>Date of Birth:</strong> {filteredStaff[selectedIndex].stfdob}
                      </li>

                      <li className="list-group-item">
                        <strong>Date of Appointment:</strong> {filteredStaff[selectedIndex].stfdoa}
                      </li>

                      <li className="list-group-item">
                        <strong>Designation:</strong> {filteredStaff[selectedIndex].designation}
                      </li>

                      <li className="list-group-item">
                        <strong>Qualification:</strong> {filteredStaff[selectedIndex].qualification}
                      </li>

                      <li className="list-group-item">
                        <strong>Experience:</strong> {filteredStaff[selectedIndex].stfyoe}
                      </li>

                    </ul>



                    <h6 className="mt-2">Achievements</h6>

                    <ul className="achievement-list">
                    {filteredStaff[selectedIndex].achievement.map((a, i) => (
                      <li key={i}>{a}</li>
                      ))}

                    </ul>

                  </div>

                </div>

              </div>



              <div className="modal-footer">

                <button
                  className="btn btn-secondary"
                  onClick={handleCloseModal}
                >
                  Close
                </button>

              </div>

            </div>

          </div>

        </div>

      )}

    </div>

  );

};

export default Staffs;